/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { JSX, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';
import ExpandableRow from '../ExpandableRow/ExpandableRow';
import { iFVSCheckboxAll, iObligation } from '../../../interfaces/interfaces';
import styles from './ExpandableTable.module.scss';

interface iProp {
  obligations: iObligation[];
  inactiveRows: boolean;
}
const ExpandableTable = ({ obligations, inactiveRows }: iProp): JSX.Element => {
  const { values }: { values: iInfringementExtensionFormValues } = useFormikContext();
  const formikContext = useFormikContext();
  const { SelectedObligationsStep5 }: { SelectedObligationsStep5: iFVSCheckboxAll[] } = values;
  const [selectedAll, setSelectedAll] = useState(false);
  const checkboxAllInit = new Array<iFVSCheckboxAll>();
  obligations.forEach((v) => {
    checkboxAllInit.push({ number: v.Number, checked: false });
  });
  const checkboxAllTrue = new Array<iFVSCheckboxAll>();
  checkboxAllInit.forEach((v) => {
    checkboxAllTrue.push({ number: v.number, checked: true });
  });
  const [allCheckedOrNot, setCheckedAll] = useState(SelectedObligationsStep5 || checkboxAllInit);
  const [isAllChecked, setAllChecked] = useState(checkboxAllTrue === SelectedObligationsStep5);
  const handleCheckedAll = (isChecked: boolean) => {
    if (isChecked) {
      setCheckedAll(checkboxAllTrue);
    } else {
      setCheckedAll(checkboxAllInit);
    }
  };
  useEffect(() => {
    if (!inactiveRows) {
      if (allCheckedOrNot?.length !== 0) {
        formikContext.setFieldValue('SelectedObligationsStep5', allCheckedOrNot);
        const checkedObs = allCheckedOrNot.reduce((accumulate, val) => {
          const checkedOb = accumulate + (val.checked ? `${val.number}, ` : '');
          return checkedOb;
        }, '').slice(0, -2);
        if (allCheckedOrNot.length === checkedObs.split(',').length) {
          setSelectedAll(true);
        } else {
          setSelectedAll(false);
        }
        if (checkedObs) {
          formikContext.setFieldValue('SelectedObNums', checkedObs);
        }
      }
    }
  }, [allCheckedOrNot, SelectedObligationsStep5]);

  return (
    <div className={styles.offenceDetails}>
      <div className={styles.detailHeadings}>
        <span>Obligation #</span>
        <span>Offence Date</span>
        <span>Offence Description</span>
        <span>Amount</span>
        <span> </span>
      </div>
      {!inactiveRows
      && obligations.map((v) => (<ExpandableRow key={v.Number} obligation={v} setCheckBox={setCheckedAll} checkedAllParent={allCheckedOrNot?.length !== 0 ? allCheckedOrNot : checkboxAllInit} disabledCheckbox={false} />
        ))}
      {inactiveRows
      && obligations.map((v) => (<ExpandableRow key={v.Number} obligation={v} setCheckBox={setCheckedAll} checkedAllParent={allCheckedOrNot?.length !== 0 ? allCheckedOrNot : checkboxAllInit} disabledCheckbox />
        ))}
      {!inactiveRows
      && (
      <div className={styles.detailValues}>
        <div className={styles.checkBoxContainer}>
          <label className={styles.inputContainer}>
            <input
              type="checkbox"
              id="checkAll"
              checked={selectedAll}
              onKeyDown={(e) => {
                if (e.key === ' ') {
                  setAllChecked(!isAllChecked);
                  handleCheckedAll(isAllChecked);
                }
              }}
              onChange={(e) => handleCheckedAll(e.target.checked)} />
            <span className={styles.inputBody}>Select all / De-select all</span>
            <span className={styles.tickContainer} />
          </label>
        </div>
      </div>
      )}
    </div>
  );
};
export default ExpandableTable;
